import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import { duplicateCheckDialog } from "Store/Actions";
import { selectShowDuplicateCheckDialog } from "Store/Selectors/Omikron";
import { Dialog } from "../Dialog";
import { Wizard } from "../../../Generic/Wizard";
import { ProjectItemContextProvider } from "../ProjectItemContext/ProjectItemContextProvider";
import { MergeContextProvider } from "./MergeContext/MergeContextProvider";
import { useDuplicateCheckWizardStyles } from "./UseDuplicateCheckStyles";
import { useDuplicateCheck } from "./UseDuplicateCheck";
import { DialogType } from "../Dialog/DialogType";

function DuplicateCheckWithContext(): JSX.Element {
  const dispatch = useDispatch();
  const styles = useDuplicateCheckWizardStyles();
  const isOpen = useSelector(selectShowDuplicateCheckDialog);
  const { pages, selectedPage, onSave } = useDuplicateCheck();
  const onDismiss = useCallback(() => dispatch(duplicateCheckDialog(false)), [dispatch]);

  if (!isOpen) {
    return null;
  }

  return (
    <Dialog isOpen={isOpen} onDismiss={onDismiss} onSave={onSave}>
      <Wizard pages={pages} selectedPage={selectedPage} useActions={false} styleSet={styles} />
    </Dialog>
  );
}

export function DuplicateCheck(): JSX.Element {
  return (
    <ProjectItemContextProvider type={DialogType.DuplicateCheck}>
      <MergeContextProvider>
        <DuplicateCheckWithContext />
      </MergeContextProvider>
    </ProjectItemContextProvider>
  );
}
